import { useEffect, useState } from "react";
import ErrorBoundary from "../../ErrorHandler/ErrorBoundary"
import NoticiaDetalhes from "../../NoticiaDetalhes"
import CorpoNoticia from "../../Postagens/Noticias/CorpoNoticia"
import api from "../../Services/api";
import GA4React from "ga-4-react";


export type ICategoria = {
  Id: number;
  Title: string;
}
export interface INoticia {
  ID: number;
  id: number;
  Resumo: string;
  Title: string;
  UrlImagem: string;
  Categoria: ICategoria;
  DataInicio: string;
  Descricao: string;
  Corpo: string;
  Extra: string;
}

export interface NoticiaDetalhesProps {
  noticia: INoticia | undefined;
}

export interface CorpoNoticiaProps {
  noticia: INoticia | undefined;
  sendEvent: (categoria: string, label: string) => void
}

export const Detalhes = () => {

  const [noticia, setNoticia] = useState<INoticia>();
  var noticiaIdStr = window.location.toString().split('Id=')[1];
  const [ga, setGa] = useState<GA4React>();
  const { REACT_APP_GOOGLE_GA_TAG } = process.env; 
  const sendEvent = (categoria: string, label: string) => {
    ga?.event(categoria, label, categoria)
}

  useEffect(() => {
    var noticiaId = parseInt(noticiaIdStr);
    api.get(`ObterNoticiasDetalhada?Id=${noticiaIdStr}`).then(response => {

      const noticia = response.data.results.find(
        (noticiaCompleta: { Id: 0 }) => noticiaCompleta.Id === noticiaId
      );
      if (noticia) {
        setNoticia(noticia);

        const { REACT_APP_GOOGLE_GA_TAG } = process.env; 
        const ga4react = new GA4React(
          REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8',
          { /* ga custom config, optional */ },
          [ /* additional code, optional */],
          3000 /* timeout, optional, defaults is 5000 */,
          /* { nonce: ['first-script-is-async','second-script'] } */
        );
        ga4react.initialize().then((ga4) => {
          
          let urlPathname = window.location.pathname + window.location.search;
          
          if (urlPathname.includes('/noticias-internas/')) {
            urlPathname = urlPathname.replace('/noticias-internas/', '/');
          }

          ga4.pageview(urlPathname, undefined, decodeURIComponent(document.title));
        }, (err) => {
          console.error(err)
        })
        setGa(ga4react);
      } else {
        throw new Error("Noticia não encontrada");
      }
    }).catch(error => {
      throw new Error(error);
    });

  }, [noticiaIdStr]);

  return (
    <>
      <ErrorBoundary>
        <NoticiaDetalhes noticia={noticia} />
      </ErrorBoundary>
      <ErrorBoundary>
        <CorpoNoticia noticia={noticia} sendEvent={sendEvent}/>
      </ErrorBoundary>
    </>
  )
}